import { Routes, Route } from 'react-router-dom';
import Nav from './Nav';
import Home from '../pages/home/Home';
import SudokuHome from '../pages/sudoku/Home';
import CrosswordHome from '../pages/crossword/Home';
import CrosswordGeneral from '../pages/crossword/General';
import CrosswordVariant from '../pages/crossword/Variant';
import { ModuleProfile } from './ModuleProfile';
import '../styles/App.css';

function Main() {
    
    return (
        <div className='main-wrapper'>
            <aside className='left-side'>
                <Nav />
            </aside>
            <main>
                <Routes>
                    <Route path='/' element={<Home />} />
                    <Route path='/sudoku' element={<SudokuHome />} />
                    <Route path='/crossword' element={<CrosswordHome />} />
                    <Route path='/crossword/general' element={<CrosswordGeneral />} />
                    <Route path='/crossword/variant' element={<CrosswordVariant />} />
                </Routes>
            </main>
            <aside className='right-side'>
                <ModuleProfile />
            </aside>
        </div>
    );
}

export default Main;